<af-full-table class="w-100 h-100"
               [showFilter]="false"
               [showImport]="false"
               [showExport]="false"
               [dataSource]="dataSource"
               [totalElements]="totalElements"
               [pageEvent]="pageEvent"
               [columnTranslationPrefixes]="columnTranslationPrefixes"
               additionalSpinnerIds="categories"
               emptyStateIconName="ic_empty_state_no_data"
               emptyStateTitleTranslationKey="i18n_af_emptyStateTitleCategoriesNotAdded"
               emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleCategoriesNotAdded"
               (tableUpdateListener)="loadPage($event)"/>
